import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { get, getPhotosBaseUrl } from '../../services/api';
import { useUI } from '../../UIContext';
import { handleErr } from '../../utils/functions';
import './news.css';

function News() {
    const { id } = useParams();
    const { setLoading, setMessage } = useUI();
    const [pageLoaded, setPageLoaded] = useState(false);
    const [news, setNews] = useState(null);

    useEffect(() => {
        async function getNewsById() {
            setLoading(true);
            setPageLoaded(false);

            await get(`/news/${id}`, true, setMessage,
                (response) => {
                    setNews(response.data || null);
                },
                (err) => {
                    handleErr(setMessage, `Não foi possível carregar a notícia: ${err}`);
                },
                () => {
                    setLoading(false);
                    setPageLoaded(true);
                }
            );
        }

        getNewsById();
    }, [id, setLoading, setMessage]);

    if (!pageLoaded)
        return null;

    function getImageName(newsItem) {
        const imagePath = newsItem?.imagePath;

        if (!imagePath)
            return undefined;

        if (imagePath.startsWith('http://') || imagePath.startsWith('https://'))
            return imagePath;

        const pathSplitted = imagePath.split('/');
        return pathSplitted[pathSplitted.length - 1];
    }

    function getNewsImage(newsItem) {
        const imageName = getImageName(newsItem);

        if (!imageName)
            return undefined;

        if (imageName.startsWith('http://') || imageName.startsWith('https://'))
            return imageName;

        const imageFolder = (newsItem?.hasModule || newsItem?.module) ? 'modules' : 'news';
        return `${getPhotosBaseUrl()}/${imageFolder}/${imageName}`;
    }

    function getNewsTitle(newsItem) {
        return newsItem?.title;
    }

    const image = getNewsImage(news);
    const title = getNewsTitle(news);
    const description = news?.description;
    const descriptionHtml = news?.descriptionHtml;

    return (
        <main className='news-page'>
            <div className='glass-bg-full-page'></div>

            <article className='news-content container-white'>
                <div className='glass-scroll-area'>
                    {image && (
                        <div className='news-cover-shell glass-effect-35'>
                            <div
                                className='news-cover-image'
                                style={{ backgroundImage: `url(${image})` }}
                                role='img'
                                aria-label={title}
                            />
                        </div>
                    )}

                    <h1>{title}</h1>

                    {descriptionHtml
                        ? <div className='news-description' dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
                        : <div className='news-description'>{description}</div>}
                </div>
            </article>
        </main>
    );
}

export default News;
